// extracted by mini-css-extract-plugin
export default {"container":"WeeklyShortlist_container__O7z0p","mainContent":"WeeklyShortlist_mainContent__WLZNP"};